import { createReducer, on } from '@ngrx/store'
import { AuthActions } from '../../auth/state/action-types'
import { CommandPaletteActions } from './command-palette.action-types'

export interface ICommandPaletteState {
    isOpen: boolean;
}

export const initState: ICommandPaletteState = {
    isOpen: false
}

export const commandPaletteReducer = createReducer(
    initState,
    on(CommandPaletteActions.openCommandPalette, (state): ICommandPaletteState => ({ ...state, isOpen: true })),
    on(CommandPaletteActions.closeCommandPalette, (state): ICommandPaletteState => ({ ...state, isOpen: false })),
    on(CommandPaletteActions.toggleCommandPalette, (state): ICommandPaletteState => ({ ...state, isOpen: !state.isOpen })),
    // Odhlášení (manuální i automatické po expiraci tokenu) sbíhá v AuthService.resetAuthContext(),
    // který dispatchne AuthActions.reset(). Paleta žije v app-root, takže by jinak zůstala viset
    // přes login stránku — proto ji při resetu auth kontextu zavíráme.
    on(AuthActions.reset, (state): ICommandPaletteState => ({ ...state, isOpen: false }))
)